// extracted by mini-css-extract-plugin
module.exports = {"service":"ServicesList_service__1TZbG","serviceImg":"ServicesList_serviceImg__2yiv7","Shape":"ServicesList_Shape__2elAN"};